import axios from 'axios'

const http = axios.create({
  baseURL: '/alicloudapi'
})
http.interceptors.response.use(res => {
  if (!res.data) {
    return res.data
  }
  if (res.data.errCode) {
    return Promise.reject(new Error(res.data.errMsg))
  }
  return res.data.data
})

export default http
